import { useTranslation } from 'react-i18next';
import { DISPLAY_CAMPAIGN_OPTIONS } from '@anytag/shared-constants';
import { useTranslateOptions } from '@anytag/shared-hooks';
import { RadiosField, RadiosFieldProps } from '@anytag/shared-molecules';
import { InfluencerFormKeys } from '../InfluencerForm';
import { InfluencerSharedKeys } from './types';

type CampaignDisplayFieldProps = Omit<RadiosFieldProps, 'name'>;
export const CampaignDisplayField = (props: CampaignDisplayFieldProps) => {
  const { t } = useTranslation();
  const displayCampaignOptions = useTranslateOptions(DISPLAY_CAMPAIGN_OPTIONS);

  return (
    <RadiosField<InfluencerFormKeys>
      help={t('Tooltip.DisplayCampaignHelp')}
      options={displayCampaignOptions}
      title={t('TextForm.Display Campaign')}
      name={InfluencerSharedKeys.campaignDisplay}
      {...props}
    />
  );
};
